import { Injectable, SecurityContext } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Injectable({
  providedIn: "root",
})
export class SanitizerService {
  constructor(private sanitizer: DomSanitizer) {}

  sanitizeFromPrototypePollution(obj: any): any {
    const blacklist = ["__proto__", "constructor", "prototype"];

    if (typeof obj !== "object" || obj === null) return obj;

    const clean: any = Array.isArray(obj) ? [] : {};

    for (const key in obj) {
      if (!blacklist.includes(key)) {
        const value = obj[key];
        clean[key] =
          typeof value === "object" && value !== null
            ? this.sanitizeFromPrototypePollution(value)
            : value;
      }
    }

    return clean;
  }

  sanitizeUrl(url: string): string {
    const parsed = new URL(url);
    const protocol = parsed.protocol;
    if (!["http:", "https:"].includes(protocol)) {
      console.warn("Unsafe protocol:", url);
      return "";
    }
    const clean = this.sanitizer.sanitize(SecurityContext.URL, url);
    return clean ?? "";
  }
}
